import { Node, mergeAttributes } from "@tiptap/core";

const RESPONSIVE_CLASS_PREFIXES = [
  "responsive-style-",
  "responsive-font-",
  "responsive-weight-",
  "responsive-align-",
];

function hasResponsiveClass(className: string | null): boolean {
  if (!className) return false;
  return className
    .split(/\s+/)
    .some((c) => c && RESPONSIVE_CLASS_PREFIXES.some((p) => c.startsWith(p)));
}

export const ResponsiveStyleSpan = Node.create({
  name: "responsiveStyleSpan",
  group: "inline",
  inline: true,
  content: "inline*",

  addAttributes() {
    return {
      class: {
        default: null,
        parseHTML: (element) => element.getAttribute("class"),
        renderHTML: (attributes) => (attributes.class ? { class: attributes.class } : {}),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (element) => {
          if (!(element instanceof HTMLElement)) return false;
          const cls = element.getAttribute("class");
          return hasResponsiveClass(cls) ? { class: cls } : false;
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(HTMLAttributes), 0];
  },
});
